"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = getLogger;
var _loglevel = _interopRequireDefault(require("loglevel"));
var _loglevelPluginPrefix = _interopRequireDefault(require("loglevel-plugin-prefix"));
// Register the prefix plugin with the root loglevel instance
_loglevelPluginPrefix["default"].reg(_loglevel["default"]);
var PREFIX_OPTIONS = {
  template: '[%t] %l [%n]:',
  levelFormatter: function levelFormatter(level) {
    return level.toUpperCase();
  },
  nameFormatter: function nameFormatter(name) {
    return name;
  },
  timestampFormatter: function timestampFormatter(date) {
    return date.toTimeString().replace(/.*(\d{2}:\d{2}:\d{2}).*/, '$1');
  },
  format: undefined
};
var DEFAULT_LEVEL = 'trace'; // TODO - SWAP VALUE BASED ON ENV (DEV VS PROD).

/**
 * Get a named logger instance.
 * @export
 * @method module:utils#getLogger
 * @param {string} name - The name of the logger instance (will be used as prefix for all log messages).
 * @param {string} level - The logger's level. One of: "trace", "debug", "info", "warn" or "error".
 * @returns {Logger} A loglevel instance that exposes trace/debug/info/warn/error methods.
 */
function getLogger() {
  var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'root';
  var level = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DEFAULT_LEVEL;
  var logger = _loglevel["default"].getLogger(name);
  logger.setLevel(level);
  _loglevelPluginPrefix["default"].apply(logger, PREFIX_OPTIONS);
  return logger;
}